import type { ReactNode } from 'react';

/**
 * Marca em SVG: dois cards sobrepostos no azul e no verde do logótipo.
 *
 * Fica em código em vez de ficheiro para nunca desaparecer por causa de um
 * caminho errado nem depender do carregamento de uma imagem no cabeçalho.
 */
export function Logo({
  className,
  compacto = false,
}: {
  className?: string;
  compacto?: boolean;
}): ReactNode {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className ?? ''}`}>
      <svg
        viewBox="0 0 32 32"
        className="size-8 shrink-0"
        role="img"
        aria-label="MemorizeCards"
      >
        <rect
          x="3"
          y="7"
          width="17"
          height="21"
          rx="3.5"
          fill="none"
          stroke="#1B75BC"
          strokeWidth="2"
          transform="rotate(-8 11.5 17.5)"
        />
        <rect
          x="11"
          y="4"
          width="18"
          height="22"
          rx="3.5"
          fill="rgba(47,224,122,0.10)"
          stroke="#2FE07A"
          strokeWidth="2"
        />
        <path
          d="M16 15.5l2.6 2.8 5.2-5.6"
          fill="none"
          stroke="#7DF5AE"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {compacto ? null : (
        <span className="font-mc-display text-lg font-semibold tracking-tight text-mc-ink">
          Memorize<span className="text-mc-accent">Cards</span>
        </span>
      )}
    </span>
  );
}
